import React, { useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { sendDataWithPost } from "../../../services/services";
import FormDialog from "../../FormDialog";
import { showSuccessMsg } from "../../../utils/toast";
import { styles } from "../../../utils/styles";
import { Add } from "@mui/icons-material";

const CreateDialog = ({ cb }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const onClose = () => {
    setOpenDialog(false);
  };

  return (
    <Stack
      direction="row"
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        mb: 2,
        alignItems: "center",
      }}
    >
      <Button
        variant="contained"
        onClick={() => setOpenDialog(true)}
        startIcon={<Add />}
        sx={{ ...styles.customButton }}
      >
        Add new MPI
      </Button>

      {openDialog && (
        <Formik
          initialValues={{
            acquirer_bin: "",
            acquirer_merchant_id: "",
          }}
          validationSchema={Yup.object().shape({
            acquirer_bin: Yup.string().required("Acquirer BIN is required"),
            acquirer_merchant_id: Yup.string().required(
              "Acquirer Merchant ID is required"
            ),
          })}
          onSubmit={async (values, { setSubmitting }) => {
            const url = "/mpi_details/create/";
            await sendDataWithPost(url, values, null, null, () => {
              showSuccessMsg();
              cb();
              onClose();
            });
            setSubmitting(false);
          }}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
            } = props;
            return (
              <FormDialog
                open={true}
                onClose={onClose}
                title="Add new MPI"
                scroll="paper"
                handleSubmit={handleSubmit}
                loading={isSubmitting}
                maxWidth="xs"
              >
                <Form autoComplete="off" noValidate>
                  <Box sx={{ m: 1 }}>
                    <Box sx={{ py: 1 }}>
                      <Typography variant="subtitle1" sx={{ pb: 0.5 }}>
                        Acquirer BIN
                      </Typography>
                      <TextField
                        name="acquirer_bin"
                        size="small"
                        fullWidth
                        value={values.acquirer_bin}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        error={Boolean(
                          touched.acquirer_bin && errors.acquirer_bin
                        )}
                        helperText={touched.acquirer_bin && errors.acquirer_bin}
                        disabled={isSubmitting}
                      />
                    </Box>

                    <Box sx={{ py: 1 }}>
                      <Typography variant="subtitle1" sx={{ pb: 0.5 }}>
                        Acquirer Merchant ID
                      </Typography>
                      <TextField
                        name="acquirer_merchant_id"
                        size="small"
                        fullWidth
                        value={values.acquirer_merchant_id}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        error={Boolean(
                          touched.acquirer_merchant_id &&
                            errors.acquirer_merchant_id
                        )}
                        helperText={
                          touched.acquirer_merchant_id &&
                          errors.acquirer_merchant_id
                        }
                        disabled={isSubmitting}
                      />
                    </Box>
                  </Box>
                </Form>
              </FormDialog>
            );
          }}
        </Formik>
      )}
    </Stack>
  );
};

export default CreateDialog;
